function isInSetupInstancePage() {
  return $("#setup-instance-page").length > 0;
}

function isInCloneInstancePage() {
  return $("#clone-instance-page").length > 0;
}

function isInSelectCollection() {
  return $("#select-collection-type").length > 0;
}
if (isInSetupInstancePage() || isInCloneInstancePage()) {
  $("#dataset-access-group").on("change", function () {
    document.getElementById("form-metadata").innerHTML = JSON.parse(
      $("#formsDetail").val(),
    )[$("#dataset-access-group").find(":selected").val()];
  });
}

if (isInSelectCollection()) {
  $('input[type="radio"]').on("change", function (e) {
    $("#allow-onyStats-certifiers-certify").removeAttr("checked");
    $("#allow-certifier-provide-certify").removeAttr("checked");
  });
}

$.fn.financialYear = function () {
  function isInGrantsDatasetsPage() {
    return $("#grant-dataset-page").length > 0;
  }
  function isInCertifierRolesPage() {
    return $("#certifier-roles-page").length > 0;
  }

  var $self = $(this);

  if (isInGrantsDatasetsPage()) {
    var grant = $("#grantCode").val();
    var grantDescription = $("#grantDescription").val();
    var instanceName = $("#instanceName").val();

    $("#instanceName").val(
      instanceName.substring(instanceName.lastIndexOf("-") + 1),
    );

    var financialYear = $("#financialYear").val();
    var VAL;
    var isExistingDataset = $("#existingDataset").val();
    var isNewDataset;
    $("#financialYear").on("change", function () {
      $("#datasetId").val(grant + "-" + $(this).val());
      $("#datasetDescription").val(grantDescription + "; " + $(this).val());
      $("#instanceName").val("01");
      $("#instanceDescription").val(
        grantDescription +
          "; " +
          $(this).val() +
          "; " +
          $("#instanceName").val(),
      );
      $("label[id='instancenamefirstpart']").html(grant + "-" + $(this).val());
      financialYear = $(this).val();
    });

    $("#datasetId").keyup(function () {
      $("label[id='instancenamefirstpart']").html($(this).val());
    });

    $("#existingDatasetId").on("change", function () {
      VAL = trim($(this).val());
      $("label[id='instancenamefirstpart']").html($(this).val());
      $("#instanceDescription").val(grantDescription + "; " + VAL);
    });

    $("#instanceName").keyup(function () {
      if (isNewDataset) {
        $("#instanceDescription").val(
          grantDescription + "; " + financialYear + "; " + $(this).val(),
        );
      } else {
        $("#instanceDescription").val(
          grantDescription + "; " + VAL + "; " + $(this).val(),
        );
      }
    });

    $("#newDataset").on("click", function () {
      $("#existingDatasetView").hide();
      $("#newDatasetView").show();
      $("#grantInstance")[0].reset();
      $("label[id='instancenamefirstpart']").html("");
      $("#existingDataset").prop("checked", false);
      isNewDataset = true;
    });
    $("#existingDataset").on("click", function () {
      $("#existingDatasetView").show();
      $("#newDatasetView").hide();
      $("#grantInstance")[0].reset();
      $("label[id='instancenamefirstpart']").html("");
      $("#existingDataset").prop("checked", true);
      isNewDataset = false;
    });

    if ($("#existingDataset").prop("checked")) {
      $("#newDatasetView").hide();
      VAL = trim($("#existingDatasetId").val());
      $("label[id='instancenamefirstpart']").html(
        $("#existingDatasetId").val(),
      );
      isNewDataset = false;
    } else {
      $("#existingDatasetView").hide();
      $("label[id='instancenamefirstpart']").html($("#datasetId").val());
      isNewDataset = true;
    }

    function trim(description) {
      var trimmedVal;
      trimmedVal = description;
      trimmedVal = trimmedVal.split("-");
      trimmedVal = trimmedVal.slice(2).join("-").trim();
      return trimmedVal;
    }
  }
};
